var React = require('react');

function Left (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 21L12.7392 24L1.04907e-06 12L12.7392 -2.85068e-07L16 3L6.4 12L16 21Z","fill":"currentColor"}));
}

Left.defaultProps = {"viewBox":"0 0 16 24","fill":"currentColor"};

module.exports = Left;

Left.default = Left;
